const $ = window.jQuery;
function updateVHVariable() {
	const visibleHeight = window.innerHeight;
	const vh = visibleHeight; // 1% of the viewport height

	// get visibleHeight - header height:
	const topNavHeight = document.querySelector('.top-nav ').offsetHeight;
	const headerHeight = document.querySelector('#header .header-container').offsetHeight;

	const visibleHeightMinusHeader = visibleHeight - headerHeight - topNavHeight;

	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--vhwh', `${visibleHeightMinusHeader}px`);
}
function realHv() {
	// Update the vh variable initially
	updateVHVariable();

	// Update the vh variable when the window is resized
	window.addEventListener('resize', updateVHVariable);
}

export default realHv;
